import { AvatarScratch } from '@zoomit/icons';
import { Flex, Skeleton } from '@zoomit/primitives';
import type { ProfileSummaryInfo } from '@zoomit/web-kit';
import { BaseMediaUrl } from '@zoomit/web-kit';
import { Avatar, cssVar, theme, Typography } from '@zoomit/zoomit-ds';

import SomethingWentWrong from '../empty-state/SomethingWentWrong';

type Props = {
  profileData: ProfileSummaryInfo | undefined;
  isProfileDataSuccess: boolean;
  isProfileDataLoading: boolean;
};

const UserInfo = (props: Props) => {
  const { profileData, isProfileDataSuccess, isProfileDataLoading } = props;

  if (isProfileDataLoading || !profileData) {
    return (
      <Flex alignItems="center" gap={0.8}>
        <Skeleton width={4.8} height={4.8} />
        <Skeleton height={1.6} width={14} />
      </Flex>
    );
  }

  if (!isProfileDataSuccess) {
    return (
      <div>
        <SomethingWentWrong />
      </div>
    );
  }

  return (
    <Flex alignItems="center" gap={0.8}>
      {profileData?.avatar ? (
        <Avatar size="large" src={`${BaseMediaUrl}/${profileData.avatar}`} />
      ) : (
        <AvatarScratch size="lg" fill={cssVar(theme.grey1)} />
      )}
      <Typography fontWeight="bold">{profileData?.displayName}</Typography>
    </Flex>
  );
};

export default UserInfo;
